var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.entry)?_c('div',_vm._l((this.entry.children),function(definition,i){return _c(_vm.getDetailComponent(definition.type),{key:i,tag:"component",class:{'pt-4': i > 0},attrs:{"entry":definition,"detailContext":_vm.detailContext}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }